import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NWClient } from '../../client/NWClient';
import {
  DocumentVaultItemModel,
  DocumentVaultDeleteData,
  DocumentVaultSearchData,
} from '../../models/document.vault.item.model';
import { revertAll, RootState } from '../../store';
import { AIDocumentContractDeleteData } from '../../models/ai.document.contract.model';

export const fetchAnotherUserDocuments = createAsyncThunk(
  'documentsAnotherUser/fetchDocuments',
  async ({ data }: DocumentVaultSearchData) => {
    const response = await NWClient.list('vault-documents', data);
    return response;
  }
);

export const deleteAnotherUserDocument = createAsyncThunk(
  'documentsAnotherUser/deleteDocument',
  async ({ id, userId }: DocumentVaultDeleteData) => {
    const response = await NWClient.delete('document-upload', id, null, { user: userId });
    return response;
  }
);

export const deleteAnotherUserDocumentContract = createAsyncThunk(
  'documentContractsAnotherUser/deleteDocumentContract',
  async ({ id, userId }: AIDocumentContractDeleteData) => {
    const response = await NWClient.delete('document-contract', id, null, { user: userId });
    return response;
  }
);

export interface DocumentsAnotherUserState {
  documentsAnotherUserList: DocumentVaultItemModel[];
  status: string;
  error: string;
}

const documentsArray: DocumentVaultItemModel[] = [];
const initialState: DocumentsAnotherUserState = {
  documentsAnotherUserList: documentsArray,
  status: 'idle',
  error: '',
};
const documentsAnotherUserSlice = createSlice({
  name: 'documentsAnotherUser',
  initialState,
  reducers: {
    clearAnotherUserDocuments(state) {
      state.documentsAnotherUserList = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAnotherUserDocuments.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAnotherUserDocuments.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (Array.isArray(action.payload)) {
          state.documentsAnotherUserList = [...action.payload];
        }
      })
      .addCase(fetchAnotherUserDocuments.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(deleteAnotherUserDocument.pending, (state) => {
        state.status = 'deleting';
      })
      .addCase(deleteAnotherUserDocument.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.documentsAnotherUserList = [...state.documentsAnotherUserList].filter(
          (el) => el.id !== action.meta.arg.id
        );
      })
      .addCase(deleteAnotherUserDocument.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(deleteAnotherUserDocumentContract.pending, (state) => {
        state.status = 'deleteLoading';
      })
      .addCase(deleteAnotherUserDocumentContract.fulfilled, (state, action) => {
        state.status = 'deleteSucceeded';
        state.documentsAnotherUserList = [...state.documentsAnotherUserList].filter(
          (el) => el.id !== action.meta.arg.id
        );
      })
      .addCase(deleteAnotherUserDocumentContract.rejected, (state, action) => {
        state.status = 'deleteFailed';
        state.error = action.error.message ?? '';
      })
      .addCase(revertAll, () => initialState);
  },
});

export default documentsAnotherUserSlice.reducer;
export const { clearAnotherUserDocuments } = documentsAnotherUserSlice.actions;
export const selectAllAnotherUserDocuments = (state: RootState) =>
  state.documentsAnotherUser.documentsAnotherUserList;
